const CirclePause = ({ size=24, color="#000000", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <circle cx="12" cy="12" r="10"/>
        <line x1="10" x2="10" y1="15" y2="9"/>
        <line x1="14" x2="14" y1="15" y2="9"/>
    </svg>
);

export default CirclePause;
